
import axios from "axios";

import { Web_separate } from "./config";

export const httpV2 = axios.create({
    baseURL: Web_separate,
    headers: {
      "Content-Type": "application/json",
    },
  });
  
  httpV2.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      config.headers.Authorization = `${user.token}`;
    }
    return config;
  });
  
  httpV2.interceptors.response.use((response) => {
    const { status, message } = response.data;
  
    if (status === 500 && message === "Authentication token invalid") {
      localStorage.clear();
      sessionStorage.setItem(
        "message",
        "Your session has been expired. Please login"
      );
      window.location.href = window.location.origin;
    }
    return response;
  });
  
  export default httpV2;